<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-inside-1_1_1049" fill="white">
<rect x="6" y="12" width="18" height="5.6" rx="1.5"/>
</mask>
<rect x="6" y="12" width="18" height="5.6" rx="1.5" fill="transparent" stroke="currentColor" stroke-width="3.2" mask="url(#path-1-inside-1_1_1049)" />
<rect x="7" y="12.9947" width="10" height="3.97869" fill="currentColor" />
</svg>
